import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgGroupby = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  return (
    <svg
      width={12}
      height={11}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M7.5 4.75h3c.398 0 .75-.328.75-.75V1a.771.771 0 0 0-.75-.75h-3a.755.755 0 0 0-.75.75v3c0 .422.328.75.75.75Zm4.031 5.04L9.562 6.577a.68.68 0 0 0-1.148 0L6.445 9.79c-.258.445.07.984.586.984h3.914c.516-.023.844-.539.586-.984ZM4.5 7.257l-.75.844V1.023C3.75.602 3.398.25 3 .25a.76.76 0 0 0-.75.773v7.079l-.773-.844C1.219 6.977.727 6.93.422 7.21a.77.77 0 0 0-.047 1.078l2.04 2.25c.28.305.82.305 1.1 0l2.04-2.25a.77.77 0 0 0-.047-1.078c-.258-.281-.727-.258-1.008.047Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default SvgGroupby;
